// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"cc_a bhh_h bhh_kf bhh_wb bhh_ss bhh_vr bhh_su bhh_sl"};